/**
 * `G3-2` (S4-9 widened by the architect's ruling of 17 October 2026): **the pièces the chargé may open before
 * she judges them.** The founder's finding at S4-9 was « the chargé cannot open ANY pièce » , the matrix's row 3
 * named two kinds and the screen and the door each carried a copy of the two. One list, read by both, so the
 * button the screen draws is exactly the call the door will answer.
 *
 * - The buyer's pièces she must verify: the identity document, the payslips, the bank statements, the
 *   employment certificate, the apport's receipt where the file still carries one, and the statement of the
 *   account the apport sits on (born by the buyer's declaration).
 * - The seller's three, once deposited.
 *
 * The EXPERTISE is not here: it stands of itself, there is nothing deposited to open. A pièce is opened only
 * once received (the door's own guard) and only by the chargé of THAT dossier (the door's scope), unchanged.
 */
export const CONSULTABLE_DOCUMENT_CODES: readonly string[] = [
  "pieceIdentite",
  "bulletinsSalaire",
  "relevesBancaires",
  "attestationTravail",
  "justificatifApport",
  "apportCompteReleve",
  "carteGrise",
  "factureProforma",
  "visiteTechnique",
];
